import { jsx } from "react/jsx-runtime";
import { createContext, useContext } from "react";
const initialHistory = {
  push: () => {
  },
  redirect: () => {
  }
};
const HistoryContext = createContext(initialHistory);
const HistoryProvider = ({ value, children }) => {
  return /* @__PURE__ */ jsx(HistoryContext.Provider, { value, children });
};
const useHistory = () => {
  const context = useContext(HistoryContext);
  if (context === void 0)
    throw new Error("`useHistory` must be used within `HistoryProvider`");
  return context;
};
export {
  HistoryContext,
  HistoryProvider,
  HistoryProvider as default,
  useHistory
};
